import React from 'react';
import {Link} from 'react-router-dom';
import {Article} from '../../types';
import {articleImage} from '../../utils/articleImage';
import {formatDate} from '../../utils/date';
import {articlePath} from '../../utils/slug';

const ArticleCard = ({article}: { article: Article }) => (
    <article className="article-card">
        <Link to={articlePath(article)} className="article-card-link">
            <div className="article-card-media">
                <img src={articleImage(article)} alt="" loading="lazy"/>
            </div>
            <div className="article-card-body">
                <time className="article-card-date" dateTime={article.date}>{formatDate(new Date(article.date))}</time>
                <h3 className="article-card-title">{article.title}</h3>
                <p className="article-card-excerpt">{article.excerpt}</p>
                <span className="article-card-more">Weiterlesen →</span>
            </div>
        </Link>
    </article>
);

export default ArticleCard;
